"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-checkbox-container {\n  display: flex;\n  height: 20px;\n  align-items: center; }\n  .bds-checkbox-container .bds-checkbox-icon-container {\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    opacity: 1;\n    vertical-align: middle;\n    display: inline-block; }\n    .bds-checkbox-container .bds-checkbox-icon-container > input[type=\"checkbox\"] {\n      position: absolute;\n      opacity: 0;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 15px;\n      height: 15px; }\n    .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 18px;\n      width: 18px;\n      border: solid #a8a8a8;\n      border-radius: 3px;\n      border-width: 2px;\n      box-sizing: border-box; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-checked {\n        border: 2px solid #161616;\n        background-color: #161616; }\n        .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-checked-disabled {\n          border: 2px solid #c6c6c6;\n          background-color: #c6c6c6; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-readonly {\n        border: 2px solid white; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-indeterminate {\n        border: 2px solid #161616; }\n        .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-indeterminate-disabled {\n          border: 2px solid #c6c6c6; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-inner-indeterminate {\n        display: block;\n        width: 100%;\n        height: 100%;\n        background-color: #161616;\n        border: 2px solid white; }\n        .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-inner-indeterminate-disabled {\n          background-color: #c6c6c6; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-inner-checked {\n        display: block;\n        position: absolute;\n        left: 5px;\n        top: 1px;\n        width: 3px;\n        height: 7px;\n        border: solid white;\n        border-width: 0 2px 2px 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n        box-sizing: unset; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-inner-readonly {\n        display: block;\n        position: absolute;\n        left: 5px;\n        top: 1px;\n        width: 3px;\n        height: 7px;\n        border: solid #161616;\n        border-width: 0 2px 2px 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n        box-sizing: unset; }\n      .bds-checkbox-container .bds-checkbox-icon-container .bds-checkbox-icon-disabled {\n        border: 2px solid #c6c6c6; }\n    .bds-checkbox-container .bds-checkbox-icon-container-hover {\n      outline: 2px solid #007fe0;\n      border-radius: 3px; }\n  .bds-checkbox-container .bds-label-container {\n    height: 19px;\n    font-size: 14px;\n    letter-spacing: 0.32px;\n    color: #393939;\n    opacity: 1;\n    font-family: \"OpenSansRegular\";\n    text-align: left;\n    vertical-align: middle;\n    margin-left: 26px; }\n";
  var fileName = "compone_checkbox";
  var element = document.querySelector("style[data-sass-component='compone_checkbox']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Checkbox = function Checkbox(_ref) {
  var _iconContainerClasses, _checkboxIconClasses, _checkboxIconInnerCla;

  var name = _ref.name,
      label = _ref.label,
      checked = _ref.checked,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      onChange = _ref.onChange,
      indeterminate = _ref.indeterminate;
  var inputRef = (0, _react.useRef)();

  var initialIconState = function initialIconState() {
    if (disabled) {
      if (checked) {
        return {
          checked: true,
          disabled: true
        };
      } else if (indeterminate) {
        return {
          indeterminate: true,
          disabled: true
        };
      } else {
        return {
          disabled: true
        };
      }
    } else {
      if (readOnly) {
        return {
          readOnly: readOnly
        };
      } else if (indeterminate) {
        return {
          indeterminate: true
        };
      } else {
        return {};
      }
    }
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      checkboxHover = _useState2[0],
      setCheckboxHover = _useState2[1];

  var _useState3 = (0, _react.useState)(initialIconState()),
      _useState4 = _slicedToArray(_useState3, 2),
      checkboxIcon = _useState4[0],
      setCheckboxIcon = _useState4[1];

  var handleIconChange = function handleIconChange() {
    if (!checked && !disabled && !indeterminate) {
      setCheckboxIcon({});
    } else if (!checked && disabled && !indeterminate) {
      setCheckboxIcon({
        disabled: true
      });
    } else if (checked && !disabled && !indeterminate) {
      setCheckboxIcon({
        checked: true
      });
    } else if (checked && disabled && !indeterminate) {
      setCheckboxIcon({
        checked: true,
        disabled: true
      });
    } else if (indeterminate && disabled && !checked) {
      setCheckboxIcon({
        indeterminate: true,
        disabled: true
      });
    } else if (indeterminate && !disabled && !checked) {
      setCheckboxIcon({
        indeterminate: true
      });
    }
  };

  var handleIconOnReadOnly = function handleIconOnReadOnly() {
    if (readOnly) {
      setCheckboxIcon({
        readOnly: readOnly
      });
    } else {
      handleIconChange();
    }
  };

  (0, _react.useEffect)(function () {
    inputRef.current.indeterminate = indeterminate;
    handleIconChange();
  }, [indeterminate]);
  (0, _react.useEffect)(function () {
    !readOnly && handleIconChange();
  }, [checked, disabled]);
  (0, _react.useEffect)(handleIconOnReadOnly, [readOnly]);
  var iconContainerClasses = (_iconContainerClasses = {}, _defineProperty(_iconContainerClasses, _constants.classes.iconContainer, true), _defineProperty(_iconContainerClasses, _constants.classes.iconContainerHover, checkboxHover), _iconContainerClasses);
  var checkboxIconClasses = (_checkboxIconClasses = {}, _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIcon, true), _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIconDisabled, checkboxIcon.disabled), _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIconChecked, checkboxIcon.checked), _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIconReadonly, checkboxIcon.readOnly), _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIconCheckedDisabled, checkboxIcon.checked && checkboxIcon.disabled), _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIconIndeterminate, checkboxIcon.indeterminate), _defineProperty(_checkboxIconClasses, _constants.classes.checkboxIconIndeterminateDisabled, checkboxIcon.indeterminate && checkboxIcon.disabled), _checkboxIconClasses);
  var checkboxIconInnerClasses = (_checkboxIconInnerCla = {}, _defineProperty(_checkboxIconInnerCla, _constants.classes.checkboxIconInnerChecked, checkboxIcon.checked), _defineProperty(_checkboxIconInnerCla, _constants.classes.checkboxIconInnerReadonly, checkboxIcon.readOnly), _defineProperty(_checkboxIconInnerCla, _constants.classes.checkboxIconInnerIndeterminate, checkboxIcon.indeterminate), _defineProperty(_checkboxIconInnerCla, _constants.classes.checkboxIconInnerIndeterminateDisabled, checkboxIcon.indeterminate && checkboxIcon.disabled), _checkboxIconInnerCla);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.checkboxContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(iconContainerClasses),
    onMouseOver: function onMouseOver() {
      !readOnly && !disabled && setCheckboxHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      !readOnly && !disabled && setCheckboxHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: _constants.checkboxType,
    role: _constants.checkboxType,
    id: name,
    name: name,
    value: name,
    disabled: disabled || readOnly,
    checked: checked,
    onChange: onChange //It will not get invoked on readOnly state.
    ,
    ref: inputRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(checkboxIconClasses)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(checkboxIconInnerClasses)
  }))), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    className: _constants.classes.labelContainer
  }, label));
};

Checkbox.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  checked: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  indeterminate: _propTypes.default.bool
};
var _default = Checkbox;
exports.default = _default;